var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TimeClock(props) {
    return (_jsx("svg", __assign({}, props, { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20', viewBox: '0 0 20 20' }, { children: _jsx("g", __assign({ fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' }, { children: _jsx("g", __assign({ stroke: '#D20400' }, { children: _jsx("g", { children: _jsx("g", { children: _jsx("g", { children: _jsxs("g", __assign({ transform: 'translate(-738 -574) translate(331 59) translate(44 358) translate(363 155) translate(0 2)' }, { children: [_jsx("circle", { cx: '10', cy: '10', r: '9.333' }, void 0),
                                    _jsx("path", { d: 'M6 6L10 10 16.667 10M10 3.333L10 4.667M10 16.667L10 15.333M3.333 10L4.667 10' }, void 0)] }), void 0) }, void 0) }, void 0) }, void 0) }), void 0) }), void 0) }), void 0));
}
